import ReactLoading from 'react-loading';
import { useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { Button } from 'components';
import { ModalCard } from './style';
import { secondary } from 'styles/colorProvider';
import { listBrands, listModels, listYearModels, getFipe } from 'api/fipe/fipeService';

export const NewFipeSearch = ({ onFinish }) => {
  const [vehicleData, setVehicleData] = useState();
  const [selectsIsLoading, setSelectsIsLoading] = useState({});
  const [selecstOptionsList, setSelectsOptionsList] = useState({
    vehicleType: [
      { Value: 1, Label: 'Carro' },
      { Value: 7, Label: 'Moto' },
    ],
    brand: [],
    model: [],
    version: [],
  });

  const loadBrands = async (vehicleType) => {
    setSelectsIsLoading({ ...selectsIsLoading, brandList: true });
    try {
      const brands = await listBrands({ type: vehicleType?.Value });
      setSelectsOptionsList({ ...selecstOptionsList, brand: brands });
      setSelectsIsLoading({ ...selectsIsLoading, brandList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, brandList: false });
    }
  };

  const loadModels = async (vehicleBrand) => {
    setSelectsIsLoading({ ...selectsIsLoading, modelsList: true });
    try {
      const models = await listModels({ brand: vehicleBrand, type: vehicleData?.type });
      setSelectsOptionsList({ ...selecstOptionsList, model: models });
      setSelectsIsLoading({ ...selectsIsLoading, modelsList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, modelsList: false });
    }
  };

  const loadVersions = async (vehicleModel) => {
    setSelectsIsLoading({ ...selectsIsLoading, versionsList: true });
    try {
      const versions = await listYearModels({ model: vehicleModel, brand: vehicleData?.id_brand, type: vehicleData?.type });
      setSelectsOptionsList({ ...selecstOptionsList, version: versions });
      setSelectsIsLoading({ ...selectsIsLoading, versionsList: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, versionsList: false });
    }
  };

  const loadFipe = async (yearModelValue, fuelCode) => {
    setSelectsIsLoading({ ...selectsIsLoading, getFipe: true });
    try {
      const resp = await getFipe({
        fuel: Number(fuelCode),
        yearModel: yearModelValue,
        model: Number(vehicleData?.id_model),
        brand: Number(vehicleData?.id_brand),
        type: Number(vehicleData?.type),
      });
      setVehicleData({
        ...vehicleData,
        brand: resp?.brand,
        model: resp?.model,
        fipe_code: resp?.fipe_code,
        value: resp?.value,
        year: resp?.year,
        id_fuel: resp?.id_fuel,
        fuel: resp?.fuel,
      });
      setSelectsIsLoading({ ...selectsIsLoading, getFipe: false });
    } catch (error) {
      setSelectsIsLoading({ ...selectsIsLoading, getFipe: false });
    }
  };

  return (
    <ModalCard>
      <div className="centralizer">
        <h1>Procurar veículo</h1>

        {/* VEHICLE TYPE */}
        <Autocomplete
          disabled={selectsIsLoading.vehicleType}
          loading={selectsIsLoading.vehicleType}
          loadingText="Carregando..."
          options={selecstOptionsList.vehicleType || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option?.Label;
          }}
          value={vehicleData?.type}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, type: data.Value });
            loadBrands(data);
          }}
          renderOption={(props, option) => {
            return (
              <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
                {option?.Label}
              </p>
            );
          }}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione o tipo" placeholder="Digite para buscar..." />
          )}
        />

        {/* VEHICLE BRAND */}
        {selectsIsLoading.brandList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.brandList || selecstOptionsList?.brand?.length < 1}
          loading={selectsIsLoading.brandList}
          loadingText="Carregando..."
          options={selecstOptionsList?.brand || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, id_brand: data.Value });
            loadModels(data.Value);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione a marca" placeholder="Digite para buscar..." />
          )}
          value={vehicleData?.type.brand}
        />

        {/* VEHICLE MODEL */}
        {selectsIsLoading.modelsList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.model || selecstOptionsList?.model?.length < 1}
          loading={selectsIsLoading.model}
          loadingText="Carregando..."
          options={selecstOptionsList?.model || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            setVehicleData({ ...vehicleData, id_model: data.Value });
            loadVersions(data.Value);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => (
            <TextField disabled={false} {...params} label="Selecione o modelo" placeholder="Digite para buscar..." />
          )}
          value={vehicleData?.type.model}
          isOptionEqualToValue={(option, value) => {
            return option.Value === value.Value;
          }}
        />

        {/* VEHICLE YEAR MODEL */}
        {selectsIsLoading.versionsList && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Autocomplete
          disabled={selectsIsLoading.version || selecstOptionsList?.version?.length < 1}
          loading={selectsIsLoading.version}
          loadingText="Carregando..."
          options={selecstOptionsList?.version || []}
          noOptionsText="Sem opções..."
          sx={{ width: 310 }}
          getOptionLabel={(option) => {
            return option.Label;
          }}
          onChange={(event, data) => {
            const [, fuelLabel] = data.Label?.split(' ');
            const fuelCode = fuelLabel === 'Gasolina' ? 1 : fuelLabel === 'Diesel' ? 3 : 2;
            setVehicleData({ ...vehicleData, yearModel: data.Value });
            loadFipe(data.Value, fuelCode);
          }}
          renderOption={(props, option) => (
            <p style={{ paddingLeft: 10, cursor: 'pointer' }} {...props} className="title">
              {option?.Label}
            </p>
          )}
          renderInput={(params) => <TextField {...params} label="Selecione a versão" placeholder="Digite para buscar..." />}
          value={vehicleData?.yearModel}
          isOptionEqualToValue={(option, value) => {
            return option?.Value === value?.Value;
          }}
        />

        {selectsIsLoading.getFipe && <ReactLoading color={secondary} height={24} width={24} type="bubbles" />}
        <Button
          loading={selectsIsLoading?.getFipe}
          disabled={!vehicleData?.value}
          width="300px"
          style={{ marginTop: 20, marginBottom: 50 }}
          onClick={() => {
            const data = {
              type: vehicleData?.type,
              id_brand: vehicleData?.id_brand,
              brand: vehicleData?.brand,
              id_model: vehicleData?.id_model,
              model: vehicleData?.model,
              year: vehicleData?.year,
              build_year: vehicleData?.year,
              value: vehicleData?.value,
              id_fuel: vehicleData?.id_fuel,
              fuel: vehicleData?.fuel,
              fipe_code: vehicleData?.fipe_code,
              id_type: vehicleData?.type,
            };
            onFinish(data);
          }}
        >
          Selecionar
        </Button>
      </div>
    </ModalCard>
  );
};
